import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.stepPersonalItems.sectionTitle',
    defaultMessage:
      'Section 4 - Damaged, Lost or Stolen Luggage, Travel Documents or Cash',
  },
  areYouClaimingForDamagedLostOrStolenLugageTravelDocumentsOrCash: {
    id:
      'fastCover.stepPersonalItems.areYouClaimingForDamagedLostOrStolenLugageTravelDocumentsOrCash',
    defaultMessage:
      'Are you claiming for Damaged, Lost or Stolen Luggage, Personal Items, Travel Documents or Cash?',
  },
  areYouClaimingForDelayedLuggage: {
    id: 'fastCover.stepPersonalItems.areYouClaimingForDelayedLuggage',
    defaultMessage: 'Are you claiming for Delayed Luggage?\n',
  },
  yes: {
    id: 'fastCover.stepPersonalItems.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepPersonalItems.no',
    defaultMessage: 'No',
  },
  areYouClaimingForLossTheftOrDamageTo: {
    id: 'fastCover.stepPersonalItems.areYouClaimingForLossTheftOrDamageTo',
    defaultMessage: 'Are you claiming for Loss, Theft or Damage to:',
  },
  passportsCreditCards: {
    id: 'fastCover.stepPersonalItems.passportsCreditCards',
    defaultMessage: 'Passports, Credit Cards & Credit Card Fraud?',
  },
  theftOfCash: {
    id: 'fastCover.stepPersonalItems.theftOfCash',
    defaultMessage: 'Theft of Cash',
  },
  luggageAndPersonalEffects: {
    id: 'fastCover.stepPersonalItems.luggageAndPersonalEffects',
    defaultMessage: 'Luggage and Personal Items',
  },
  luggageInclude: {
    id: 'fastCover.stepPersonalItems.luggageInclude',
    defaultMessage:
      'Luggage includes your bags, clothes, devices and other personal belongings.',
  },
  toAssistYourClaim: {
    id: 'fastCover.stepPersonalItems.toAssistYourClaim',
    defaultMessage: 'To assist your claim:',
  },
  toAssistYourClaimDetail1: {
    id: 'fastCover.stepPersonalItems.toAssistYourClaim',
    defaultMessage:
      'We may need the below documents, please provide those that are applicable.',
  },
  toAssistYourClaimDetail2: {
    id: 'fastCover.stepPersonalItems.toAssistYourClaim',
    defaultMessage: 'We may contact you to request further documentation',
  },
  document: {
    id: 'fastCover.stepPersonalItems.document',
    defaultMessage: 'Documents',
  },
  document1: {
    id: 'fastCover.stepPersonalItems.document1',
    defaultMessage:
      'Police report or written report from a relevant authority or Travel Provider (Airline, hotel, Cruise Liner, Tour Company etc.)',
  },
  document2: {
    id: 'fastCover.stepPersonalItems.document2',
    defaultMessage: 'Damage or Repair report',
  },
  document3: {
    id: 'fastCover.stepPersonalItems.document3',
    defaultMessage: 'Quote for repair or replacement',
  },
  document4: {
    id: 'fastCover.stepPersonalItems.document4',
    defaultMessage:
      'Purchase receipt or other Evidence of Ownership for each item claimed',
  },
  document5: {
    id: 'fastCover.stepPersonalItems.document5',
    defaultMessage:
      "For all losses or delays caused by your Transport Provider, a 'Property Irregularity Report' from the Transport Provider",
  },
  document6: {
    id: 'fastCover.stepPersonalItems.document6',
    defaultMessage:
      'Written evidence from the Transport Provider confirming the days and hours your luggage was delayed and the time that it was returned to you',
  },
  document7: {
    id: 'fastCover.stepPersonalItems.document7',
    defaultMessage: 'Receipts for essential clothing and toiletries purchased',
  },
  document8: {
    id: 'fastCover.stepPersonalItems.document8',
    defaultMessage:
      'For Cash claims, Bank or Credit Card statements or ATM or Currency Conversion receipts showing withdrawal of funds',
  },
  document9: {
    id: 'fastCover.stepPersonalItems.document9',
    defaultMessage:
      'For mobile phone claims please block the IMEI letter with your network provider',
  },
  provideExplanation: {
    id: 'fastCover.stepPersonalItems.provideExplanation',
    defaultMessage:
      'If you cannot provide any of the above documents, please provide an explanation why you are unable to.',
  },
  luggageWasLostStolenOrDamaged: {
    id: 'fastCover.stepPersonalItems.luggageWasLostStolenOrDamaged',
    defaultMessage:
      'If your luggage was lost, stolen or damaged please tell us:',
  },
  howItHappened: {
    id: 'fastCover.stepPersonalItems.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.stepPersonalItems.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.stepPersonalItems.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.stepPersonalItems.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.stepPersonalItems.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.stepPersonalItems.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.stepPersonalItems.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.stepPersonalItems.delay',
    defaultMessage: 'Delay',
  },
  whoDidYouReportThisTo: {
    id: 'fastCover.stepPersonalItems.whoDidYouReportThisTo',
    defaultMessage: 'Who did you report this to?',
  },
  police: {
    id: 'fastCover.stepPersonalItems.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.stepPersonalItems.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.stepPersonalItems.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.stepPersonalItems.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.stepPersonalItems.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.stepPersonalItems.other',
    defaultMessage: 'Other',
  },
  notReported: {
    id: 'fastCover.stepPersonalItems.notReported',
    defaultMessage: 'Not Reported',
  },
  otherDescription: {
    id: 'fastCover.stepPersonalItems.otherDescription',
    defaultMessage: 'If other, please describe',
  },
  reportReferenceNumber: {
    id: 'fastCover.stepPersonalItems.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },
  descriptionOfItem: {
    id: 'fastCover.stepPersonalItems.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.stepPersonalItems.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.stepPersonalItems.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.stepPersonalItems.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.stepPersonalItems.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.stepPersonalItems.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.stepPersonalItems.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.stepPersonalItems.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.stepPersonalItems.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  item: {
    id: 'fastCover.stepPersonalItems.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.stepPersonalItems.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.stepPersonalItems.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepPersonalItems.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepPersonalItems.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.stepPersonalItems.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.stepPersonalItems.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.stepPersonalItems.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.stepPersonalItems.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.stepPersonalItems.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.stepPersonalItems.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.stepPersonalItems.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.stepPersonalItems.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.stepPersonalItems.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.stepPersonalItems.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.stepPersonalItems.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.stepPersonalItems.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.stepPersonalItems.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.stepPersonalItems.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.stepPersonalItems.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.stepPersonalItems.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  other1: {
    id: 'fastCover.stepPersonalItems.other1',
    defaultMessage: 'Proof of loss (i.e. police report, report to hotel, airline, transport provider)',
  },
  other2: {
    id: 'fastCover.stepPersonalItems.other2',
    defaultMessage: 'Proof of ownership/receipts/bank statements for each item',
  },
  other3: {
    id: 'fastCover.stepPersonalItems.other3',
    defaultMessage: 'Written confirmation of an IMEI block from your network provider',
  },
  other4: {
    id: 'fastCover.stepPersonalItems.other4',
    defaultMessage: 'A damage/repair report or quotation',
  },
  other5: {
    id: 'fastCover.stepPersonalItems.other5',
    defaultMessage: 'Written confirmation of luggage delay',
  },
  other6: {
    id: 'fastCover.stepPersonalItems.other6',
    defaultMessage: 'Receipts, bank statements and/or proof of payment for each expense being claimed',
  },
  itemWithIdx: {
    id: 'fastCover.stepPersonalItems.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.stepPersonalItems.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepPersonalItems/messages.js